"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import { useSession } from "next-auth/react"
import { useContext, useCallback } from "react"
import { ClientSessionContext } from "./ClientSessionContext"
import { getSessionResourceScope, type ClientSessionUpdate } from "./clientSession"

type SessionUser = {
  idToken?: string | null
  accessToken?: string | null
  refreshToken?: string | null
  userId?: number | null
  providerId?: number | null
  orgId?: string | number | null
  authRole?: string | null
  expiresAt?: number
  error?: string
  sub?: string
}

type SessionShape = {
  user?: SessionUser
}

const useSessionAttributes = () => {
  const { data: providerSession, status } = useSession()
  const credentials = useContext(ClientSessionContext)
  const session =
    credentials?.isCurrentSession(providerSession) === false ? null : providerSession
  const update = useCallback(
    (payload?: ClientSessionUpdate) => {
      if (!credentials) throw new Error("Session updates require SessionManager")
      return credentials.updateSession(payload)
    },
    [credentials],
  )
  const forceRefresh = useCallback(() => update({ forceRefresh: true }), [update])

  const sessionData = session as SessionShape | null
  const sessionUser = sessionData?.user
  const hasSession = !!sessionUser?.idToken && !sessionUser?.error
  const isAuthenticated = status !== "unauthenticated" && hasSession

  return {
    session,
    status,
    isAuthenticated,
    isInitializing: status === "loading" && !hasSession,
    isRefreshing: status === "loading" && hasSession,
    resourceScope: isAuthenticated ? getSessionResourceScope(sessionData) : null,
    update,
    forceRefresh,
    idToken: sessionUser?.idToken ?? null,
    accessToken: sessionUser?.accessToken ?? null,
    refreshToken: sessionUser?.refreshToken ?? null,
    userId: sessionUser?.userId ?? null,
    providerId: sessionUser?.providerId ?? null,
    orgId: sessionUser?.orgId ?? null,
    authRole: sessionUser?.authRole ?? null,
  }
}

export default useSessionAttributes
